
import React, { useState } from "react"
import { Layout, Radio, Space, Spin, Table, Tooltip, Typography } from "antd"
import LayoutHeader from "../layouts/partials/LayoutHeader"
import { apiCall, apiDownload } from "../utils/Api"
export default function USCanPriceComparison() {

    const [loading, setLoading] = useState(false);
    const [results, setResults] = useState({ markup_results: [] });

    const [sort, setSort] = useState("avg_markup");
    const fetchComparisons = () => {
        setLoading(true)
        apiCall("report/getuscanmarkup", {}, (_s, _r) => {
            if (_s) {
                setResults(_r);
            }
            setLoading(false)
        })
    }

    useState(fetchComparisons, []);

    const getLink = (_obj, _group = "backlist", _txt = false) => {

        const title_count = _obj?.[_group]?.titles || "";

        return (<a onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            downloadFile(_obj, _group, _txt);

        }}>{(_txt) ? "(txt)" : title_count}</a>)
    }


    const downloadFile = (_obj, _group = "backlist", _txt = false) => {

        let _o = {
            location: _obj.location,
            region: _group,
            csv: !_txt,
        }

        apiDownload(_o, "report/getuscanmarkup", true);
    }

    const columns = [

        {
            title: <small></small>, dataIndex: 'dist_top', key: 'dist_top', children: [
                {
                    title: <small></small>, dataIndex: 'dist_mid', key: 'dist_mid', children: [
                        {
                            title: <small>Distributor</small>, dataIndex: 'distributor', width: 130, key: 'distributor', render: (e, f) => {
                                return (<div><strong>{f.location}</strong><div>{f.name}</div></div>)
                            }
                        }
                    ]
                },
            ]
        },

        {
            title: <small>All Titles</small>, dataIndex: 'all_titles', key: 'all_titles', children: [
                {
                    title: <small></small>, dataIndex: 'backlist', key: 'backlist', children: [
                        {
                            title: <small>Titles</small>, dataIndex: 'backlist.titles', key: 'backlist.titles', render: (e, f) => {
                                return (
                                    <>
                                        <div>{getLink(f, "backlist")}</div>
                                        <div>{getLink(f, "backlist", true)}</div>
                                    </>
                                )
                            }
                        },
                    ]
                },
                {
                    title: <small>Markup</small>, dataIndex: 'backlist.markup', key: 'backlist.markup', children: [
                        { title: <small>Avg</small>, dataIndex: 'backlist.avgmarkup', key: 'actibacklist.avgmarkupon', render: (e, f) => { return (<strong>{f.backlist?.avgmarkup}</strong>) } },
                        { title: <small>Min</small>, dataIndex: 'backlist.minmarkup', key: 'backlist.minmarkup', render: (e, f) => f.backlist?.minmarkup },
                        { title: <small>Max</small>, dataIndex: 'backlist.maxmarkup', key: 'backlist.maxmarkup', render: (e, f) => f.backlist?.maxmarkup },
                    ]
                },
                {
                    title: <small>
                        <div>Blue = 0.72 <small>(Today's CAD/USD rate)</small></div>
                        <div>Green = rate+10%</div>
                    </small>, dataIndex: 'backlist.legend', key: 'backlist.legend', children: [
                        {
                            title: <small>Markup Spread</small>, dataIndex: 'backlist.img', key: 'backlist.img', render: (e, f) => {
                                return (<img onError={(e) => (e.currentTarget.style.display = 'none')} src={"https://bookmanager.com/" + f.backlist?.img} />)
                            }
                        },
                    ]
                },
            ]
        },
        {
            title: <small>New Releases (published in the past 3 months)</small>, dataIndex: 'new_releases', key: 'new_releases', children: [
                {
                    title: <small></small>, dataIndex: 'new', key: 'new', children: [
                        {
                            title: <small>Titles</small>, dataIndex: 'new.titles', key: 'new.titles', render: (e, f) => {
                                return (
                                    <>
                                        <div>{getLink(f, "new")}</div>
                                        <div>{getLink(f, "new", true)}</div>
                                    </>
                                )
                            }
                        },
                    ]
                },
                {
                    title: <small>Markup</small>, dataIndex: 'new.markup', key: 'new.markup', children: [
                        { title: <small>Avg</small>, dataIndex: 'new.avgmarkup', key: 'new.avgmarkup', render: (e, f) => { return (<strong>{f.new?.avgmarkup}</strong>) } },
                        { title: <small>Min</small>, dataIndex: 'new.minmarkup', key: 'new.minmarkup', render: (e, f) => f.new?.minmarkup },
                        { title: <small>Max</small>, dataIndex: 'new.maxmarkup', key: 'new.maxmarkup', render: (e, f) => f.new?.maxmarkup },
                    ]
                },
                {
                    title: <small>
                        <div>Blue = 0.72 <small>(Today's CAD/USD rate)</small></div>
                        <div>Green = rate+10%</div>
                    </small>, dataIndex: 'new.legend', key: 'new.legend', children: [
                        {
                            title: <small>Markup Spread</small>, dataIndex: 'new.img', key: 'new.img', render: (e, f) => {
                                return (<img onError={(e) => (e.currentTarget.style.display = 'none')} src={"https://bookmanager.com/" + f.new?.img} />)
                            }
                        },
                    ]
                },
            ]
        },

        {
            title: <small>Forthcoming (published in next 6 months)</small>, dataIndex: 'forthcoming_section', key: 'forthcoming_section', children: [
                {
                    title: <small></small>, dataIndex: 'forthcoming', key: 'forthcoming', children: [
                        {
                            title: <small>Titles</small>, dataIndex: 'forthcoming.titles', key: 'forthcoming.titles', render: (e, f) => {
                                return (
                                    <>
                                        <div>{getLink(f, "forthcoming")}</div>
                                        <div>{getLink(f, "forthcoming", true)}</div>
                                    </>
                                )
                            }
                        },
                    ]
                },
                {
                    title: <small>Markup</small>, dataIndex: 'forthcoming.markup', key: 'forthcoming.markup', children: [
                        { title: <small>Avg</small>, dataIndex: 'forthcoming.avgmarkup', key: 'forthcoming.avgmarkup', render: (e, f) => { return (<strong>{f.forthcoming?.avgmarkup}</strong>) } },
                        { title: <small>Min</small>, dataIndex: 'forthcoming.minmarkup', key: 'forthcoming.minmarkup', render: (e, f) => f.forthcoming?.minmarkup },
                        { title: <small>Max</small>, dataIndex: 'forthcoming.maxmarkup', key: 'forthcoming.maxmarkup', render: (e, f) => f.forthcoming?.maxmarkup },
                    ]
                },
                {
                    title: <small>
                        <div>Blue = {results?.xchg} <small>(Today's CAD/USD rate)</small></div>
                        <div>Green = rate+10%</div>
                    </small>, dataIndex: 'forthcoming.legend', key: 'forthcoming.legend', children: [
                        {
                            title: <small>Markup Spread</small>, dataIndex: 'forthcoming.img', key: 'forthcoming.img', render: (e, f) => {
                                return (<img onError={(e) => (e.currentTarget.style.display = 'none')} src={"https://bookmanager.com/" + f.forthcoming?.img} />)
                            }
                        },
                    ]
                },
            ]
        },
    ]

    const drawSort = () => {
        return (
            <Radio.Group
                size="small"
                value={sort}
                onChange={(e) => {
                    setSort(e.target.value)
                }}
                buttonStyle="solid">
                <Radio.Button value={"avg_markup"}>
                    <small>Avg Markup</small>
                </Radio.Button>
                <Radio.Button value={"distributor"}>
                    <small>Distributor</small>
                </Radio.Button>
            </Radio.Group>
        )
    }

    const getData = () => {
        let ret = [...results?.markup_results] || [];
        if (sort === "avg_markup") {
            return ret.sort((a, b) => parseFloat(b["backlist"].avgmarkup) - parseFloat(a["backlist"].avgmarkup));
        } else {
            return ret.sort((a, b) => a.name.localeCompare(b.name));
        }
    }

    return (
        <Layout className="layout">
            <Spin spinning={loading}>
                <LayoutHeader
                    title="US to Canadian Price Comparison"
                    description={<><div className="float-flex"><div>Last compiled on: {results?.date}</div><Space>Sort by: {drawSort()}</Space></div></>}
                />
                <div style={{ "padding": "20px" }}>
                    <Table
                        size="small"
                        bordered
                        pagination={false}
                        loading={loading}
                        columns={columns}
                        dataSource={getData()}
                    />
                    <div className="shim" /><div className="shim" /><div className="shim" />
                    <Typography.Paragraph>This report uses the Canadian prices from in-stock items found at the suppliers above and compares them against the in-stock prices found at Ingram wholesale. Currently ranked titles are used to compile the results. This report is updated daily using the most recent Pubstock feeds that we receive from suppliers.</Typography.Paragraph>
                    <Typography.Paragraph>The New Releases column includes only titles with publication dates from the past three months. Compare this to the "All Titles" column to determine the current pricing strategy. Click on any of quantities to view the titles that were used to build the summary.</Typography.Paragraph>
                    <Typography.Paragraph>The graph's red line shows the range of exchange rates being used for titles. The blue line represents the current Canadian exchange rate (updated daily). The green line represents the current exchange rate plus 10%.</Typography.Paragraph>
                    <Typography.Paragraph>Note: Canadian book distribution rights guidelines suggest that book retailers are obligated to purchase from Canadian sources so long as Canadian prices set by distributors are no more than 10% greater than the current exchange rate.</Typography.Paragraph>
                    <Typography.Paragraph>We welcome any suggestions or comments to make this report more useful for everyone in the Canadian book industry.</Typography.Paragraph>
                </div>
            </Spin>
        </Layout>
    )
}